import { createRoot } from 'react-dom/client'
import { Suspense } from 'react'
import './styles.css'
import { App } from './App'

function Overlay() {
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', width: '100%', height: '100%' }}>
      <a href="https://www.linkedin.com/in/alice-gr%C3%A9goire-715164209/">
        Contact me
      </a>
      <div style={{ position: 'absolute', top: 40, left: 40, fontSize: '16px', alignItems: 'center', display: 'flex' }}><img src="alice.jpg" alt="alice picture" style={{ width: '40px', borderRadius: '100px', marginRight: '6px' }} /><span style={{ color: 'lightgray' }}>Alice Gregoire </span> - Architect Student</div>
      <div style={{ position: 'absolute', bottom: 40, right: 40, fontSize: '13px' }}>Nancy, France</div>
    </div>
  )
}

createRoot(document.getElementById('root')).render(
  <>
    <Suspense fallback={null}>
      <App />
    </Suspense>
    <Overlay />
  </>
)
